export const TODAY = 'TODAY';
export const YESTERDAY = 'YESTERDAY';
export const TOMORROW = 'TOMORROW';
export const THIS_WEEK = 'THIS_WEEK';
export const LAST_WEEK = 'LAST_WEEK';
export const NEXT_WEEK = 'NEXT_WEEK';
export const THIS_MONTH = 'THIS_MONTH';
export const LAST_MONTH = 'LAST_MONTH';
export const NEXT_MONTH = 'NEXT_MONTH';
export const THIS_QUARTER = 'THIS_QUARTER';
export const LAST_QUARTER = 'LAST_QUARTER';
export const NEXT_QUARTER = 'NEXT_QUARTER';
export const THIS_YEAR = 'THIS_YEAR';
export const LAST_YEAR = 'LAST_YEAR';
export const NEXT_YEAR = 'NEXT_YEAR';